const HEADERS = [
  '业务员勤策经销商大区',
  '宴席用酒品牌',
  '用酒品项',
  '业务员勤策经销商名称',
  '宴席供酒单位编码',
  '宴席供酒单位名称',
  '宴席申报单号',
  '宴席政策',
  '宴席类型',
  '宴席主宴时间',
  '宴席举办地（省）',
  '宴席举办地（市）',
  '宴席举办地（区）',
  '宴席举办地（详细地址）',
  '宴席举办地（经纬度解析）',
  '宴席举办地（经度）',
  '宴席举办地（纬度）',
  '酒店名称',
  '包间名称',
  '预计开展桌数',
  '登记用酒箱数',
  '登记用酒盒数',
  '登记用酒瓶数',
  '登记用酒总瓶数',
  '退酒箱数',
  '退酒盒数',
  '退酒瓶数',
  '退酒总瓶数',
  '开瓶数',
  '追加用酒箱数',
  '追加用酒盒数',
  '追加用酒瓶数',
  '发放核销券数量',
  '核销核销券数量',
]

const ROWS = [
  ['四川大区', '五粮春', '五粮春（二代）', '自贡五香酒业有限公司', 'ZD1683598088184', '优家便利店', 'YX202609171765587', '2026年五粮春宴席（二代）', '婚宴', '2026-09-23 11:00:00', '四川省', '自贡市', '富顺县', '富顺', '四川省自贡市富顺县兜山镇207省道', '105.01288', '29.081787', '坝坝宴', '无', '48', '5', '30', '0', '60', '0', '0', '0', '0', '0', '5', '30', '0', '0', '0'],
  ['晋冀大区', '五粮春', '五粮春（二代）', '朔州市朔城区酒久源酒类经销部', 'ZD1734769419539', '瑞通泸州老窖店', 'YX202609211775735', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '山西省', '朔州市', '山阴县', '北周庄镇', '山西省朔州市山阴县北周庄镇二淅线', '112.827965', '39.59598', '北周庄老红场地', '一楼', '25', '9', '0', '0', '54', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '四川春享汇供应链管理有限公司', 'ZD320402', '御岭超市', 'YX202609201773970', '2026年五粮春宴席（二代）', '白事', '2026-09-23 12:00:00', '四川省', '成都市', '简阳市', '成都市简阳市', '四川省成都市简阳市贾家街道318国道东部新区种子乐园', '104.35543823242188', '30.452993392944336', '铂宴主题宴会酒店', '大厅', '24', '5', '0', '0', '30', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '内江春盛酒业有限责任公司', 'ZD477143', '嘉越达商贸部', 'YX202609201774392', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 11:00:00', '四川省', '内江市', '东兴区', '田家镇石缸村', '四川省内江市东兴区田家镇K10县道', '105.10602', '29.68917', '田家镇石缸湾村', '坝坝宴', '36', '6', '0', '0', '36', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '绵阳市润品源商贸有限公司', 'ZD168114', '宇罗粮油副食', 'YX202609201774244', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 12:00:00', '四川省', '绵阳市', '江油市', '武都', '四川省绵阳市江油市武都镇长城路', '104.77747', '31.881277', '画屏园', '大厅', '12', '2', '0', '0', '12', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '自贡五香酒业有限公司', 'ZD729568', '徐健食品经营部', 'YX202609171764473', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 11:00:00', '四川省', '自贡市', '大安区', '自贡', '四川省自贡市大安区回龙镇红珠村村民委员会', '105.0421', '29.296856', '坝坝宴', '大厅', '40', '8', '6', '0', '54', '0', '0', '0', '0', '0', '8', '6', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '四川省欣信智宇商贸有限公司', 'ZD228490', '湘源商贸行', 'YX202609181768854', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '四川省', '德阳市', '旌阳区', '旌阳区', '四川省德阳市旌阳区孝感街道东电宾馆(黄河西路)', '104.39347839355469', '31.14703941345215', '柏隆张家院坝', '坝坝', '20', '5', '2', '0', '32', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '四川春享汇供应链管理有限公司', 'ZD1682743714785', '芳惠源食品经营部', 'YX202609181768874', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '四川省', '成都市', '成华区', '东和苑', '四川省成都市成华区龙潭街道东和苑(锦绣花城南区店)锦绣花城南区', '104.17187', '30.71063', '东和苑', '大厅', '10', '4', '0', '0', '24', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '成都众诚春香供应链管理有限责任公司', 'ZD1715842729499', '鸿辉商贸', 'YX202609161763050', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 18:00:00', '四川省', '成都市', '新都区', '四川省成都市新都区斑竹园街道安桥村1组88号水云轩生态苑', '四川省成都市新都区斑竹园街道新斑路一段', '104.066376', '30.830765', '水云轩', '水云轩', '18', '3', '0', '0', '18', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '自贡五香酒业有限公司', 'ZD1692762439547', '许平酒坊专卖店', 'YX202609141758569', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 11:00:00', '四川省', '自贡市', '大安区', '自贡', '四川省自贡市大安区牛佛镇牛佛镇政府', '105.03312', '29.377575', '坝坝宴', '大厅', '40', '5', '0', '0', '30', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '中江腾晖商贸有限公司', 'ZD157952', '通济惠嫒超市', 'YX202609041715064', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 12:00:00', '四川省', '德阳市', '中江县', '中江', '四川省德阳市中江县通济镇245国道', '104.77627', '31.082415', '坝坝宴', '坝坝宴', '18', '5', '0', '0', '30', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '三台玖新品商贸有限公司', 'ZD159912', '鑫泉鑫超市', 'YX202609181768208', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 00:39:00', '四川省', '绵阳市', '三台县', '金凤凰酒店', '四川省绵阳市三台县北坝镇酪香路66号金凤凰大酒店', '105.08637237548828', '31.095901489257812', '金凤凰酒店', '大厅', '6', '0', '4', '0', '4', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '广元亿祥商贸有限责任公司', 'ZD248046', '长健超市', 'YX202609211776014', '2026年五粮春宴席（二代）', '其他', '2026-09-23 11:00:00', '四川省', '广元市', '旺苍县', '旺苍', '四川省广元市旺苍县东河镇新华街552号米仓山大酒店', '106.28558', '32.22824', '米仓山大酒店', '大厅', '12', '0', '18', '0', '18', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '绵阳聚智商贸有限公司', 'ZD1703476237784', '乐和超市', 'YX202609171765666', '2026年五粮春宴席（二代）', '生日宴', '2026-09-23 12:00:00', '四川省', '绵阳市', '涪城区', '哦', '四川省绵阳市涪城区石塘街道绵阳邦达商贸有限责任公司', '104.73361', '31.447277', '坝坝', '李', '6', '0', '12', '0', '12', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '四川久源道商贸有限公司', 'ZD098499', '九寨沟县酷族超市', 'YX202609211775951', '2026年五粮春宴席（二代）', '甘孜、阿坝、凉山宴席类型(专用)', '2026-09-23 10:00:00', '四川省', '阿坝藏族羌族自治州', '九寨沟县', '九寨沟县城和平一村', '四川省阿坝藏族羌族自治州九寨沟县南坪镇九寨人家老房子客栈', '104.23461', '33.267414', '和平一村', '大厅', '30', '0', '0', '12', '12', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
  ['四川大区', '五粮春', '五粮春（二代）', '绵阳市润品源商贸有限公司', 'ZD181779', '彭氏副食', 'YX202609201774228', '2026年五粮春宴席（二代）', '家宴', '2026-09-23 12:00:00', '四川省', '绵阳市', '江油市', '武都镇', '四川省绵阳市江油市武都镇长城路', '104.77747', '31.881277', '画屏园', '大厅', '12', '0', '3', '0', '3', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0'],
]

export function banquetImportDemoRows () {
  return ROWS.map(function (cells) {
    const row = {}
    HEADERS.forEach(function (header, index) {
      row[header] = cells[index]
    })
    return row
  })
}

export function banquetImportDemoHeader () {
  return HEADERS.map(function (text) {
    return {key: text, text: text}
  })
}



// WEBPACK FOOTER //
// ./src/views/banquet-task/banquet-task-import-demo.js